import request from "@/utils/request";

export function getById(id) {
    return request({
        url: "/cloud/news/" + id,
        method: "get"
    });
}

export function lastList(limit) {
    return request({
        url: "/cloud/news/lastList?limit=" + limit,
        method: "get"
    });
}

export function getPagesByCondition(data) {
    return request({
        url: "/cloud/news/getPagesByCondition",
        method: "post",
        data: data,
    });
}

export function add(data) {
    return request({
        url: "/cloud/news/add",
        method: "post",
        data: data,
    });
}

export function update(data) {
    return request({
        url: "/cloud/news/update",
        method: "post",
        data: data,
    });
}

export function updateStatus(data) {
    return request({
        url: "/cloud/news/updateStatus",
        method: "post",
        data: data,
    });
}

export function del(id) {
    return request({
        url: "/cloud/news/del/" + id,
        method: "post"
    });
}